import React from 'react'

import { P } from '@mxenabled/mxui'

import Stack from '@mui/material/Stack'

import { ThemedSVGImage } from '../ThemedSVGImage'

import { ReactComponent as BeatErrorView } from './images/BeatErrorView.svg'

export interface CardErrorProps {
  erroredText: string
}

const imageStyles = {
  marginBottom: 16,
  maxWidth: 120,
  width: '100%',
}

export const CardError: React.FC<CardErrorProps> = ({ erroredText }) => {
  return (
    <Stack
      sx={{
        alignItems: 'center',
      }}
    >
      <ThemedSVGImage divProps={{ style: imageStyles }} image={BeatErrorView} />
      <P color="secondary" sx={{ mx: 8, mb: 8 }} variant="subtitle2">
        {erroredText}
      </P>
    </Stack>
  )
}
